module.exports = __webpack_public_path__ + "img/done.c8af3ddc.gif";